import { FC, ReactNode } from 'react'
import { ListRenderItem, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'

interface ColumnsProps {
    data: any[]
    renderColumn?: ListRenderItem<any>
    style?: StyleProp<ViewStyle>
}

const Columns: FC<ColumnsProps> = ({ data, renderColumn, style }) => {
    return (
        <View style={[styles.columnsContainer, style]}>
            {data.map((item) => ({ item })).map(renderColumn as () => ReactNode)}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    columnsContainer: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    titlesContainer: {
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    title: {
        paddingHorizontal: 12,
    },
})

export default Columns
